import './style.less';
import { isEqual } from 'lodash';

export default () => {
  return ($scope, $q, $state, $stateParams, $uibModalInstance, CategoryClass, ApiClass) => {
    'ngInject';

    $scope.createEvent = () => {
      $scope.close();
      $state.go('app.eventManager', $stateParams);
    };

    $scope.onFilter = function(stCtrl) {
      const oldFiltered = $scope.filtered || [];
      const newFiltered = stCtrl.getFilteredCollection();
      if (!isEqual(oldFiltered, newFiltered)) $scope.selectAllCourses = false;
      $scope.filtered = stCtrl.getFilteredCollection();
    };

    $scope.selectAll = () => {
      $scope.filtered.forEach(events => (events.selected = $scope.selectAllCourses));
    };

    $scope.close = () => $uibModalInstance.dismiss('cancel');

    $scope.add = () => {
      const events = $scope.events.filter(({ selected }) => selected);
      $uibModalInstance.close(events);
    };

    const filters = {
      'filters:includePastEvents': true,
      'filters:startTime': $stateParams.startTime,
      'filters:endTime': $stateParams.endTime
    };

    $q.all([
      CategoryClass.loadCategories(),
      ApiClass.eventsGet(
        { eventType: false, pastEvents: true },
        {},
        {
          queryParams: {
            external: true,
            manage: true,
            ...['course_id', 'course_name', 'delivery_method', 'event_id', 'external', 'hours'].reduce((acc, prop) => {
              acc[`projection:${prop}`] = 1;

              return acc;
            }, {}),
            ...filters
          }
        }
      )
    ])
      .then(([categories, { data: { events } }]) => {
        $scope.events = events;
        $scope.categoryDict = categories;
        $scope.loaded = true;
      })
      .catch(error => {
        throw error;
      });
  };
};



// WEBPACK FOOTER //
// ./src/app/modals/addExternalEvents/index.js